__turbopack_context__.v({
  "centerBanner": "cta-banner-module__7BD4Oq__centerBanner",
  "centerContent": "cta-banner-module__7BD4Oq__centerContent",
  "centerImage": "cta-banner-module__7BD4Oq__centerImage",
  "centerOverlay": "cta-banner-module__7BD4Oq__centerOverlay",
});
